import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';
import { CurrentUserState } from '../../../state/current-user.state';

interface PortalCard {
  title: string;
  description: string;
  icon: string;
  route: string;
  color: string;
  disabled: boolean;
}

@Component({
  selector: 'app-portal-home',
  standalone: true,
  imports: [MatIconModule, MatCardModule],
  templateUrl: './portal-home.component.html',
  styleUrls: ['./portal-home.component.scss']
})
export class PortalHomeComponent {
  private router = inject(Router);
  private currentUserState = inject(CurrentUserState);

  cards = computed<PortalCard[]>(() => {
    const canAccessDirectors = this.currentUserState.user()?.canAccessDirectors ?? false;
    return [
      {
        title: 'Directors Database',
        description: 'Browse and search director profiles',
        icon: 'groups',
        route: '/portal/directors',
        color: '#7b1fa2',
        disabled: !canAccessDirectors
      },
      {
        title: 'Data for Statistics',
        description: 'Filter data and export statistical reports',
        icon: 'query_stats',
        route: '/portal/statistics',
        color: '#1976d2',
        disabled: false
      }
    ];
  });

  navigateTo(card: PortalCard) {
    if (card.disabled) return;
    this.router.navigate([card.route]);
  }
}
